import React from 'react';
import { StyledTableContent, StyledTableHeader } from '../../table/StyledTable';
import { IPageData } from 'types/rest/IPageData';
import { Grid, PageLoading } from 'ui-toolkit';
import { StyledTableRow, StyledTableHeaderValue } from './MatchedActualStyles';
import { IEscrowActualIncomingAchData } from 'types/accounting/data/IEscrowActualIncomingAchData';
import { IEscrowActualIncomingAchQuery } from 'types/accounting/query/IEscrowActualIncomingAchQuery';
import { MatchActualACHDepositRow } from './MatchActualACHDepositRow';
import { MatchActualACHDepositSearchBar } from './MatchActualACHDepositSearchBar';
import { Pager } from 'ui-toolkit/components/DataGrid/tabbedTable/BottomPager';

interface IMatchActualACHDepositTableProps {
  data: IPageData<IEscrowActualIncomingAchData>;
  isQueryFetching: boolean;
  query: IEscrowActualIncomingAchQuery;
  selectedId?: string;
  setSelectedId: (detail: string | undefined) => void;
  setQuery: (query: IEscrowActualIncomingAchQuery) => void;
}

export const MatchActualACHDepositTable: React.FC<IMatchActualACHDepositTableProps> = ({
  query,
  data,
  isQueryFetching,
  selectedId,
  setSelectedId,
  setQuery,
}) => {
  const columns = ['Completed At Date', 'Memo', 'Sender', 'Received', 'Selected'];

  const onPageChange = (newPage: number) => {
    setQuery({ ...query, pageNumber: newPage });
  };
  const onPageSizeChange = (newPageSize: number) => {
    setQuery({ ...query, pageSize: newPageSize });
  };

  return (
    <>
      <Grid rowGap={'baseUnit'}>
        <MatchActualACHDepositSearchBar setQuery={setQuery} query={query} />
        <StyledTableHeader>
          <StyledTableRow columnsLength={columns.length}>
            {columns.map((t) => (
              <StyledTableHeaderValue key={t}>{t}</StyledTableHeaderValue>
            ))}
          </StyledTableRow>
        </StyledTableHeader>
        <PageLoading isLoading={isQueryFetching}>
          <StyledTableContent className={'pb-4'}>
            {data?.content?.map((item) => (
              <MatchActualACHDepositRow
                achDeposit={item}
                key={item.id}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
              />
            ))}
          </StyledTableContent>
          <Pager
            total={data.totalElements}
            page={data.pageNumber}
            pageSize={data.pageSize}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        </PageLoading>
      </Grid>
    </>
  );
};
